import { User } from "../Model/User";
import { v4 as getUuid } from 'uuid';
import { MANAGER_ID } from "../environment";
export class UserFactory {
    createUser(id = getUuid(), accountId = null, creationDate = new Date().toISOString(), lastLoginDate = null, lastActivityDate = null, enabled = true, typeId = MANAGER_ID, name = '', email = '') {
        return new User(id, accountId, creationDate, lastLoginDate, lastActivityDate, enabled, typeId, name, email);
    }
}
